export const getInstallmentCounts = ((product) => {
    // eslint-disable-next-line default-case
    switch (product) {
        case 'mtpl':
        case 'mtpl-combined':
        case 'mtpl-accident-passengers':
        case 'mtpl-assistance':
            return [1, 2, 4];
        case 'travel-assistance':
            return [1];
    }
});

export const installmentColors = {
    1: 'success',
    2: 'info',
    4: 'primary',
};
export const policyStatusColors = {
    ACTIVE: 'success',
    CANCELLED: 'dark',
    TERMINATED: 'danger',
};
export const EUR_COEFFICIENT = 0.5113;
